import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const WarningIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M15.91 13.976 8.578 1.308a.693.693 0 0 0-1.154 0L.09 13.976a.667.667 0 0 0 .577 1h14.668a.667.667 0 0 0 .577-1ZM8.805 5.642l-.315 4.4H7.51l-.297-4.4h1.59ZM8 12.976a.978.978 0 1 1 0-1.956.978.978 0 0 1 0 1.956Z", fill: "currentColor" })));
});
WarningIcon.displayName = 'WarningIcon';
export default WarningIcon;
